import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";

import { Grid, Box, Fab, CardHeader, Typography, IconButton } from '@mui/material';
import { Months, firstDayOfYear } from '../../Stats/statsFunctions';
import DatePicker from '../../common/DatePicker';
import Dialog from '../../common/Dialog';
// import StackedStats from '../../Stats/StackedStats';
import StackedGeneral from '../../Stats/StackedGeneral';
import Spinner from '../../common/Spinner';
import StackedStatsIn from '../../Stats/StackedStatsIn';
import DoughnutChart from '../../Stats/DoughnutChart';
import { InputSelectNative } from '../../common/Form';
import { BarChartOutlined, PieChartRounded } from '@mui/icons-material';
import DoughnutChartIn from '../../Stats/DoughnutChartIn';


class IncomeStats extends Component {
	state = { 
        filter_payment: "all",
        filter_period: "currentMonth",
        start_date: this.props.start_date || firstDayOfYear,
        end_date: this.props.end_date || new Date(),
        openForm: false,
        chart: "bar",
        fieldBy: "income_post",
        fieldName: "post_name"
    }
    
	componentDidMount() {
        window.scrollTo(0, 0);
	}
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name] : value
        })
        if (value === "year"){
            this.setState({
                start_date: firstDayOfYear,
                end_date: new Date(),
            })
        }
    }

    handleChangeField = (fieldBy, fieldName) => {
        this.setState({ fieldBy, fieldName})
    }
	render() {
        const { INCOMES, POSTS, BANKS } = this.props;
        const { fieldBy, fieldName} = this.state;

        console.log('====================================');
        console.log({ fieldBy, fieldName});
        console.log('====================================');
		return (
            <Box>
                <Box>  
                    <CardHeader
                        action={ this.state.chart === "donut" ?
                            <Fab 
                                onClick={() => this.setState({chart: "bar"})} 
                                color="secondary"
                                size="small"
                            >
                                <BarChartOutlined />
                            </Fab>
                        :
                            <Fab
                                onClick={() => this.setState({chart: "donut"})} 
                                color="primary"
                                size="small"
                            >
                                <PieChartRounded />
                            </Fab>
                        }
                        title="Répartition des Recettes"
                    />
                    {this.props.STATE.incomes.fetching ?
                        <Spinner />
                        :    
                        <Box p={1}>
                            <Grid container spacing={1} >
                                <Grid item xs={12} sm={6} >
                                    <InputSelectNative
                                        label="État Paiement"
                                        onChange={this.handleChange}
                                        value={this.state.filter_payment}
                                        labelWidth={110} 
                                        name="filter_payment" 
                                        id="filter_payment"
                                        options={[
                                            <option value="all" >Toutes les recettes</option>,
                                            <option value="spent" >Validée</option>,
                                            <option value="not_spent" >Non Validées</option>
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <InputSelectNative
                                        label="Période"
                                        onChange={this.handleChange}
                                        value={this.state.filter_period}
                                        labelWidth={60} 
                                        name="filter_period" 
                                        id="filter_period"
                                        options={[
                                            <option value="week" >7 derniers jours</option>,
                                            <option value="currentMonth" >{Months[new Date().getMonth() ]}</option>,
                                            <option value="year" >{new Date().getFullYear()}</option>,
                                            <option value="custom" >Autre</option>
                                        ]}
                                    />
                                </Grid>
                                {this.state.filter_period === "custom" && 
                                    <Fragment >
                                        <Grid item xs={12} sm={6} >
                                            <DatePicker
                                                required
                                                label="Du"
                                                handleChange={(date)=> this.setState({ start_date: date})}
                                                value={this.state.start_date}
                                                id="start_date"
                                                maxDate={this.state.end_date || new Date()}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} >
                                            <DatePicker
                                                required
                                                label="Au"
                                                handleChange={(date)=> this.setState({ end_date: date})}
                                                value={this.state.end_date}
                                                id="end_date"
                                                maxDate={new Date()}
                                                minDate={this.state.start_date || new Date()}
                                            />
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                            <Box p={3}>
                                {this.state.chart === "donut" &&
                                    <DoughnutChartIn 
                                        {...this.props} 
                                        {...this.state}
                                        fieldBy={fieldBy}
                                        fieldName={fieldName} 
                                        changeFieldBy={this.handleChangeField} 
                                        general
                                    />
                                }
                                {this.state.chart === "bar" && !isEmpty(INCOMES) &&
                                    <StackedStatsIn
                                        POSTS={POSTS}
                                        BANKS={BANKS}
                                        INCOMES={Object.values(INCOMES)}
                                        {...this.state}
                                        fieldBy={fieldBy}
                                        fieldName={fieldName}
                                        changeFieldBy={this.handleChangeField}
                                        general
                                    />
                                }
                            </Box>
                        </Box>
                    }
                </Box>
            </Box>
        );
	}
}


export default IncomeStats;